import * as React from "react";

import { Button } from "@progress/kendo-react-buttons";

export default function DrawerMenuButton() {
  return <Button icon="menu" />;
}
